import { Spinner } from "@shopify/polaris";
import { useSmartrrFlags } from "@smartrr/shared/LaunchDarkly";
import { Navigate } from "@tanstack/react-router";
import { useLDClient } from "launchdarkly-react-client-sdk";

import { Onboarding } from "@vendor-app/v3/pages/Onboarding/Onboarding";

export function OnboardingRoute(): JSX.Element {
  const { onboardingV2 } = useSmartrrFlags();
  const launchDarklyClient = useLDClient();

  if (launchDarklyClient === undefined) {
    return <Spinner />;
  }

  if (onboardingV2 !== true) {
    return <Navigate to="/admin" />;
  }

  return <Onboarding />;
}
